import actions from './actions';
import requests from './requests';


const yodomains = {
  actions,
  requests
};

export {actions, requests};
export default yodomains;
module.exports = yodomains;
